import classNames from "classnames";
import React, { useCallback } from "react";
import useIsMobile from "../../common/utils/useIsMobile";
import Icon from "../../common/components/Icon";
import Image from "next/image";
import { toCockpitImagePath } from "../../cms/components/CockpitImage";
import { Link } from "../../../navigation";

const ShopNavigationItem = ({
  entry,
  navigateTo,
  isSelected,
  className = "",
}) => {
  const isMobile = useIsMobile();
  const { data, url, title } = entry;

  const handleMouseEnter = useCallback(() => {
    if (!isMobile) navigateTo?.(entry);
  }, [isMobile, navigateTo, entry]);

  const handleClick = useCallback(
    (e) => {
      if (isMobile && entry.children?.length) {
        e.preventDefault();
        e.stopPropagation();
        navigateTo?.(entry);
      }
    },
    [isMobile, entry, navigateTo],
  );

  return (
    <Link
      href={typeof url === "string" ? url : url?.route || "#"}
      onMouseEnter={handleMouseEnter}
      onClick={handleClick}
      className={classNames(
        "d-inline-flex align-items-center gap-2 fs-6 fs-lg-7 nav-hover public-shop-nav-item",
        { active: isSelected },
        className,
      )}
    >
      <div className="d-flex align-items-center gap-3">
        {data?.image?.path && (
          <Image
            src={toCockpitImagePath(data.image.path)}
            alt={title}
            width={32}
            height={32}
            style={{ objectFit: "contain", objectPosition: "center" }}
            unoptimized={data?.image?.path?.endsWith(".svg")}
          />
        )}
        {title}
        {isSelected && (
          <Icon className="color-secondary icon--lg" icon="arrow-right" />
        )}
      </div>
    </Link>
  );
};

const ShopNavigationColumn = ({ navigationStack = [], onNavigateTo }) => {
  const isMobile = useIsMobile();
  const lastItem = navigationStack[navigationStack.length - 1] || {};
  const { title, subtitle, url } = lastItem;

  const isSelected = useCallback(
    (item) => navigationStack.some((n) => n.title === item.title),
    [navigationStack],
  );

  if (!navigationStack.length && !isMobile) return null;
  const normalizedCurrentRootUrl = url?.route || url;
  return (
    <div className="row">
      {title && (
        <h3 className="mb-2 ps-3 color-secondary hide-on-not-mobile col-12 mkt-nav-button mt-2 mt-lg-0">
          <Link href={normalizedCurrentRootUrl}>{title}</Link>
        </h3>
      )}
      {subtitle && (
        <Link href="/#" className="mb-3">
          {subtitle}
        </Link>
      )}

      {!isMobile &&
        navigationStack.map((rootItem, index) => (
          <div
            key={rootItem.title + index}
            className="hide-on-mobile navigation-list-column col-lg-4"
          >
            {rootItem.children
              ?.filter(({ meta }) => !meta?.isCallToAction)
              ?.map((item, rootIndex) => (
                <div
                  key={item.title + rootIndex}
                  className="col-12 navigation-list-item"
                >
                  <ShopNavigationItem
                    navigateTo={onNavigateTo}
                    entry={item}
                    isSelected={isSelected(item)}
                  />
                </div>
              ))}
          </div>
        ))}

      {isMobile &&
        lastItem?.children?.map((item, navIndex) => (
          <div key={item.title + navIndex} className="col-12">
            <ShopNavigationItem
              navigateTo={onNavigateTo}
              entry={item}
              isSelected={isSelected(item)}
              className="hide-on-not-mobile"
            />
          </div>
        ))}
    </div>
  );
};

export default ShopNavigationColumn;
